import { createSlice } from '@reduxjs/toolkit';

const genreLookup = createSlice({
  name: 'genreLookup',
  initialState: {},
  reducers: {
    setGenreLookup(state, action) {
      return action.payload;
    }
  }
});

export const { setGenreLookup } = genreLookup.actions;
export default genreLookup.reducer;